import { LiveWidgetStore } from "@state/stores/live-widgets";
import { createContext } from "react";

// @ts-expect-error we don't pass default value for this context.
export const LiveWidgetStoreContext = createContext<LiveWidgetStore>();
